export default function Sobre() {
  return (
    <section id="sobre" className="py-12 px-6 text-center bg-white bg-opacity-20 backdrop-blur-lg">
      <h3 className="text-2xl font-bold mb-4">Sobre Nós</h3>
      <p className="max-w-2xl mx-auto">A Mecânica Pichinin atua em Jaú com serviços de alta qualidade, garantindo segurança e confiança. Parceiros da Bosch Service, oferecemos diagnósticos precisos e atendimento de excelência.</p>
    </section>
  );
}
